export default function yesOrNo(value) {
    switch (Boolean(value)) {
        case true:
            return 'Yes';
        case false:
            return 'No';
        default:
            return '';
    }
}
